import React from 'react';
import { Icon } from './Icon.js';
export const IconHashtag = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 16H20", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M4 8H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M7.64551 22H5.62695L8.35449 2H10.373L7.64551 22Z", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("path", { d: "M15.6455 22H13.627L16.3545 2H18.373L15.6455 22Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconHashtag.js.map